import * as Sentry from '@sentry/react';

export const linkClarityToSentry = () => {
  if (typeof window.clarity !== 'function') return;

  window.clarity('metadata', metadata => {
    if (!metadata?.sessionId) return;

    const sessionUrl = `https://clarity.microsoft.com/player/${metadata.projectId}/${metadata.userId}/${metadata.sessionId}`;

    Sentry.setContext('clarity', {
      sessionId: metadata.sessionId,
      sessionUrl,
      userId: metadata.userId,
      projectId: metadata.projectId,
    });
    Sentry.setTag('clarity.sessionId', metadata.sessionId);
    Sentry.setTag('clarity.sessionUrl', sessionUrl);
  });
};
